import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';

import { ToggleButtonProps } from '../toggle-button/toggle-button';

@Component({
  selector: 'fin-toggle-button-group',
  templateUrl: './toggle-button-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleButtonGroupComponent implements AfterViewInit {
  @HostBinding('class') classAttribute = 'flex flex--center flex--middle';

  @Input({ required: true })
  name: string;

  @Input({ required: true })
  buttons: ToggleButtonProps[];

  @Output()
  activeButtonName = new EventEmitter<string>();

  ngAfterViewInit(): void {
    this.activeButtonName.emit(this.buttons[0].name);
  }

  onToggle(name: string): void {
    this.activeButtonName.emit(name);
  }
}
